module.exports = __webpack_public_path__ + "img/wrong2.af97c94a.jpg";